var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_109_216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7485 1.25252L6.36633 7.63338M8.47919 12.6493C8.50135 12.7046 8.53988 12.7517 8.58961 12.7844C8.63933 12.8171 8.69787 12.8338 8.75737 12.8323C8.81687 12.8308 8.87448 12.8111 8.92246 12.7759C8.97045 12.7407 9.00651 12.6916 9.02582 12.6353L12.8178 1.5524C12.8365 1.50072 12.84 1.44479 12.8281 1.39115C12.8161 1.33751 12.7891 1.28839 12.7503 1.24954C12.7114 1.21068 12.6623 1.18369 12.6086 1.17173C12.555 1.15977 12.4991 1.16333 12.4474 1.182L1.36309 4.97354C1.30679 4.99284 1.25774 5.0289 1.22253 5.07688C1.18732 5.12486 1.16764 5.18246 1.16611 5.24195C1.16459 5.30144 1.1813 5.35997 1.21401 5.40969C1.24671 5.45941 1.29385 5.49794 1.34908 5.5201L5.97531 7.37503C6.12156 7.43358 6.25443 7.52113 6.36592 7.63241C6.47742 7.74369 6.56522 7.87639 6.62403 8.02251L8.47919 12.6493Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_109_216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.895757b3ee4279df919c6697063e0e28.svg";
export { ForwardRef as ReactComponent };